import React from 'react';
import { useStyletron } from 'baseui';
import { SIZE as DividerSize, StyledDivider } from 'baseui/divider';
import { ListItem } from 'baseui/list';
import { Select, SIZE as SelectSize, TYPE as SelectType } from 'baseui/select';
import { HIERARCHY as TagHierarchy, Tag } from 'baseui/tag';
import type { Theme } from 'baseui/theme';
import { LabelLarge, LabelXSmall } from 'baseui/typography';
import type { SearchOptionWithIcon } from '../common';
import { RenderSearchOptionLabel } from '../common';
type AnnotationFilterOption = SearchOptionWithIcon;

// Tag overrides
const objectsTagOverrides = {
  Root: {
    style: ({
      $theme
    }: {
      $theme: Theme;
    }) => ({
      margin: 0,
      padding: `${$theme.sizing.scale0} ${$theme.sizing.scale100}`,
      backgroundColor: $theme.colors.contentInverseTertiary,
      height: $theme.sizing.scale700
    })
  }
};
export const filterOptionOverrides = {
  ControlContainer: {
    style: ({
      $theme
    }) => ({
      borderRadius: $theme.borders.radius500
    })
  },
  DropdownListItem: {
    style: ({
      $theme
    }) => ({
      padding: `${$theme.sizing.scale100} ${$theme.sizing.scale600}`
    })
  },
  ValueContainer: {
    style: ({
      $theme
    }) => ({
      paddingTop: $theme.sizing.scale100,
      paddingBottom: $theme.sizing.scale100
    })
  }
};
export const listItemOverrides = {
  Root: {
    style: ({
      $theme
    }) => ({
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      width: '100%',
      paddingTop: $theme.sizing.scale600
    })
  },
  Content: {
    style: () => ({
      padding: 0,
      margin: 0,
      minHeight: 'auto'
    })
  }
};

// ObjectsPanelTitle component
export interface AnnotationFilterProps {
  annotationCount: number;
  title: string;
  selectedFilter: string | undefined;
  placeholder?: string;
  endEnhancer?: () => React.ReactNode;
  filterOptions?: AnnotationFilterOption[];
  onFilterChange?: (value: string) => void;
}
export const AnnotationFilter = ({
  annotationCount,
  title,
  selectedFilter,
  endEnhancer,
  filterOptions,
  onFilterChange,
  placeholder
}: AnnotationFilterProps) => {
  const [css, theme] = useStyletron();
  const selectedOption = filterOptions?.find(filter => selectedFilter === filter.value);
  return <div>
      {filterOptions && filterOptions.length > 0 && <>
          <Select value={selectedOption && [selectedOption]} options={filterOptions} onChange={params => {
        onFilterChange?.(params.value[0]?.value);
      }} placeholder={placeholder} labelKey="label" valueKey="value" size={SelectSize.compact} type={SelectType.search} overrides={filterOptionOverrides} getOptionLabel={option => <RenderSearchOptionLabel {...(option.option as AnnotationFilterOption)} />} />
          <StyledDivider $size={DividerSize.cell} $style={{
        marginTop: theme.sizing.scale600,
        marginBottom: 0
      }} />
        </>}
      <ListItem hasDivider={false} overrides={listItemOverrides}>
        <div className={css({
        display: 'flex',
        alignItems: 'center',
        gap: theme.sizing.scale500
      })}>
          <LabelLarge margin={0}>{title}</LabelLarge>
          <Tag closeable={false} overrides={objectsTagOverrides} hierarchy={TagHierarchy.primary}>
            <LabelXSmall margin={0} color={theme.colors.backgroundAlwaysLight}>
              {annotationCount}
            </LabelXSmall>
          </Tag>
        </div>
        {endEnhancer && endEnhancer()}
      </ListItem>
    </div>;
};